import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';

//img
import arrowCircleEmptyMedium from '../../assets/icons/arrow-circle-empty-light-left.svg';

const PaginationPrevious = ({clang, setPreviousPage}) => {
    return (
        <button className="pagination__previous" onClick={() => setPreviousPage()} title={lang[clang].pagination.previous_title}>
            <img className="pagination__previous__img" src={arrowCircleEmptyMedium} alt="" />
            {lang[clang].pagination.previous}
        </button>
    );
};

PaginationPrevious.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(PaginationPrevious);



// WEBPACK FOOTER //
// ./src/components/pagination/PaginationPrevious.js